import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { backendRequest, backendRequestAndNotification } from '../api'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from 'react-toastify'

const Exclusives = ({ ws }) => {

    const [tasks, setTasks] = useState([])
    const [filteredTasks, setFilteredTasks] = useState([])
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [lookup, setLookup] = useState('')
    const [formData, setFormData] = useState({
        offerId: '',
        provider: 'WaxRewards'
    })

    const history = useNavigate()
    const redirectToPage = (url) => history('/' + url)

    useEffect(() => {
        getTasks()
    }, [])

    useEffect(() => {
        if (lookup.trim() === '') {
            setFilteredTasks(tasks)
        } else {
            const q = lookup.toLowerCase()
            const filtered = tasks.filter(t =>
                (t.offerId || '').toLowerCase().includes(q) ||
                (t.name || '').toLowerCase().includes(q) ||
                (t.provider || '').toLowerCase().includes(q) ||
                (t.category || '').toLowerCase().includes(q)
            )
            setFilteredTasks(filtered)
        }
    }, [tasks, lookup])

    const getTasks = async () => {
        try {
            const res = await backendRequest('/admin/tasks/all', 'GET')
            if (res.type === 'success') {
                setTasks(res.tasks || [])
            } else {
                setTasks([])
            }
        } catch (e) {
            setTasks([])
        }
    }

    const addOfferId = async () => {
        const trimmed = (formData.offerId || '').trim()
        if (!trimmed) return
        try {
            const res = await backendRequestAndNotification('/admin/tasks/add-task', 'POST', {
                offerId: trimmed,
                provider: formData.provider || 'WaxRewards'
            })
            if (res.type === 'success') {
                setFormData({ offerId: '', provider: 'WaxRewards' })
                setShowCreateForm(false)
                getTasks()
            }
        } catch (e) {
            // error toast handled by backendRequestAndNotification
        }
    }

    const deleteTask = async (task, e) => {
        e.stopPropagation()
        if (!window.confirm(`Delete offer "${task.name || task.offerId}"? This cannot be undone.`)) return
        try {
            // expects a server route to delete by _id or offerId
            const res = await backendRequestAndNotification('/admin/tasks/delete', 'POST', {
                _id: task._id,
                offerId: task.offerId
            })
            if (res.type === 'success') {
                getTasks()
            }
        } catch (e) {}
    }

    const formatDate = (timestamp) => {
        if (!timestamp) return ''
        return new Date(timestamp).toLocaleDateString()
    }

    const copyOfferUrl = async (task, e) => {
        e.stopPropagation()
        if (!task?.url) return
        try {
            await navigator.clipboard.writeText(task.url)
            toast.success(`Offer URL copied`, {
                position: "bottom-left",
                autoClose: 3000,
                theme: 'colored',
            })
        } catch (err) {
            console.error('Failed to copy: ', err)
        }
    }

    return (
        <>
            <div className='campaigns-container'>

                <div className='create-section'>
                    <button
                        className='create-btn'
                        onClick={() => setShowCreateForm(!showCreateForm)}
                    >
                        {showCreateForm ? 'Cancel' : 'Add Offer ID'}
                    </button>

                    {showCreateForm && (
                        <div className='create-form'>
                            <div className='form-row'>
                                <input
                                    placeholder='Offer ID (e.g., 21-74620)'
                                    value={formData.offerId}
                                    onChange={(e) => setFormData({ ...formData, offerId: e.target.value })}
                                />
                                <select
                                    value={formData.provider}
                                    onChange={(e) => setFormData({ ...formData, provider: e.target.value })}
                                    style={{ border: 'unset', outline: 'unset', height: 45, color: 'white', backgroundColor: '#21284C', padding: '0 15px', borderRadius: 6, fontSize: 14 }}
                                >
                                    <option value="WaxRewards">WaxRewards</option>
                                </select>
                            </div>
                            <button className='submit-btn' onClick={addOfferId}>
                                Save Offer ID
                            </button>
                        </div>
                    )}
                </div>

                <div className='search'>
                    <input
                        placeholder='Search by offerId, name, provider, or category'
                        value={lookup}
                        onChange={(e) => setLookup(e.target.value)}
                    />
                    <button onClick={() => setLookup('')}>Clear</button>
                </div>

                <div className='table'>
                    <div className='table-header'>
                        <p>Offer ID</p>
                        <p>Name</p>
                        <p>Provider</p>
                        <p>Reward</p>
                        <p>Geos</p>
                        <p>Devices</p>
                        <p>Updated</p>
                        <p>Actions</p>
                    </div>

                    {Array.isArray(filteredTasks) && filteredTasks.map((task) => (
                        <div
                            className='table-row'
                            key={task._id || task.taskId || task.offerId}
                            onClick={(e) => copyOfferUrl(task, e)}
                            title={task.url ? `Click to copy offer URL` : 'No URL'}
                        >
                            <p className='code'>{task.offerId}</p>
                            <p>{task.name || '(pending)'}</p>
                            <p>{task.provider || 'WaxRewards'}</p>
                            <p className='green'>{(task.reward || 0).toLocaleString()}</p>
                            <p
                                className='blue geos'
                                title={Array.isArray(task.countries) ? task.countries.join(', ') : '—'}
                            >
                                {Array.isArray(task.countries) ? task.countries.join(', ') : '—'}
                            </p>
                            <p>{Array.isArray(task.devices) ? task.devices.join(', ') : '—'}</p>
                            <p onClick={(e) => e.stopPropagation()}>{formatDate(task.updated_at || task.created_at)}</p>
                            <p onClick={(e) => e.stopPropagation()}>
                                <span
                                    className='red'
                                    onClick={(e) => deleteTask(task, e)}
                                    title='Delete Task'
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </span>
                            </p>
                        </div>
                    ))}

                    {filteredTasks.length === 0 && (
                        <div className='no-results'>
                            <p>No tasks found{lookup.trim() ? ` matching "${lookup}"` : ''}</p>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                .campaigns-container {
                    width: 100%;
                }

                .create-section {
                    margin-bottom: 20px;
                }

                .create-btn {
                    border: unset;
                    outline: unset;
                    padding: 12px 20px;
                    color: white;
                    background-color: #4FAC7C;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 14px;
                    margin-bottom: 15px;
                }

                .create-btn:hover {
                    background-color: #3e8a63;
                }

                .create-form {
                    background-color: #141A31;
                    padding: 20px;
                    border-radius: 12px;
                    margin-top: 10px;
                }

                .form-row {
                    display: flex;
                    gap: 15px;
                    margin-bottom: 15px;
                }

                .form-row input {
                    border: unset;
                    outline: unset;
                    flex: 1;
                    height: 45px;
                    color: white;
                    background-color: #21284C;
                    padding: 0px 15px;
                    border-radius: 6px;
                    font-size: 14px;
                }

                .form-row input::placeholder {
                    color: rgba(255, 255, 255, 0.5);
                }

                .submit-btn {
                    border: unset;
                    outline: unset;
                    width: 100%;
                    height: 45px;
                    color: white;
                    background-color: #4DAEFF;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 14px;
                }

                .submit-btn:hover {
                    background-color: #3d8acc;
                }

                .search {
                    display: flex;
                    margin-bottom: 15px;
                    height: 50px;
                    gap: 15px;
                }

                .search input {
                    border: unset;
                    outline: unset;
                    width: 100%;
                    color: white;
                    background-color: #21284C;
                    padding: 0px 10px;
                    border-radius: 6px;
                }

                .search button {
                    border: unset;
                    outline: unset;
                    width: 150px;
                    color: white;
                    background-color: #4DAEFF;
                    border-radius: 6px;
                    cursor: pointer;
                }

                .table {
                    overflow-x: auto;
                }

                .table-header, .table-row {
                    background-color: #141A31;
                    display: flex;
                    border-radius: 12px;
                    padding: 0px 15px;
                    font-size: 14px;
                    align-items: center;
                    min-width: 900px;
                    height: 50px;
                }

                .table-row {
                    margin-top: 15px;
                    cursor: pointer;
                    transition: all .2s;
                }

                .table-row:hover {
                    background-color: #1e2648;
                }

                .table-row > * {
                    flex: 1;
                    text-align: center;
                }

                .table-header > * {
                    flex: 1;
                    text-align: center;
                    opacity: 0.5;
                }

                .green {
                    color: #4FAC7C;
                }

                .blue {
                    color: #4F8DDE;
                }

                .red {
                    color: #ac4f4f;
                }

                .code {
                    font-weight: 600;
                    color: #F1C475;
                }

                p {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .no-results {
                    margin-top: 15px;
                    background-color: #141A31;
                    border-radius: 12px;
                    padding: 15px;
                    min-width: 900px;
                    text-align: center;
                    opacity: 0.8;
                }

                .geos {
                    cursor: help; /* indicates there’s more info on hover */
                }
            `}</style>
        </>
    )
}

export default Exclusives